import React, { useState } from 'react';
import portrait from '../../assets/about/nadya-chub.jpg';
import MeetingRequestModal from '../../components/contact/MeetingRequestModal';
import FadeUp from '../../components/common/FadeUp';
import {
  ACHIEVEMENTS,
  BIO_PARAGRAPHS,
  BOOKS,
  BRAND_GROUPS,
  EDUCATION,
  HERO_TAGS,
  PULL_STATS,
  SEGMENTS,
  TIMELINE,
  VALUES,
} from './aboutData';
import './About.css';

const SectionTitle = ({ num, title, titleEm }) => (
  <div className="about-section-head">
    {num ? <span className="about-section-num">{num}</span> : null}
    <h2 className="about-section-title">
      {title}
      {titleEm ? <> <em>{titleEm}</em></> : null}
    </h2>
  </div>
);

const About = () => {
  const [isMeetingOpen, setMeetingOpen] = useState(false);

  return (
    <div className="about-page">
      <FadeUp className="about-hero">
        <div className="about-hero-copy">
          <div className="about-eyebrow">
            <span className="about-eyebrow-line" />
            Обо мне
          </div>
          <h1>
            MARKET DIR —
            <br />
            <em>это я</em>
          </h1>
          <p className="about-hero-lead">
            Надежда Чуб — директор по маркетингу. 12+ лет в маркетинге. Прошла путь от специалиста по
            рекламе до руководителя digital-направления в корпорации. Управляла бюджетами в сотни тысяч
            долларов и командами в пяти странах. Теперь помогаю малому и среднему бизнесу выстроить
            системный эффективный маркетинг, опираясь на данные и клиентский опыт.
          </p>
          <div className="about-hero-tags">
            {HERO_TAGS.map((tag) => (
              <span key={tag} className="about-htag">
                {tag}
              </span>
            ))}
          </div>
        </div>
        <div className="about-hero-photo">
          <img src={portrait} alt="Обо мне" loading="lazy" />
          <div className="about-hero-photo-tag">MARKET DIR</div>
        </div>
      </FadeUp>

      <FadeUp className="about-section" delay={40}>
        <div className="about-pull-stats">
          {PULL_STATS.map((item) => (
            <div key={item.num} className="about-pstat">
              <div className="about-pstat-num">{item.num}</div>
              <div className="about-pstat-label">{item.label}</div>
            </div>
          ))}
        </div>
      </FadeUp>

      <FadeUp as="section" className="about-section" delay={60}>
        <SectionTitle num="01" title="Мой" titleEm="путь" />
        {BIO_PARAGRAPHS.map((text) => (
          <p key={text.slice(0, 24)} className="about-bio-text">
            {text}
          </p>
        ))}
      </FadeUp>

      <FadeUp as="section" className="about-section" delay={80}>
        <SectionTitle num="02" title="Где я работала" titleEm="последние 3 года" />
        <div className="about-timeline">
          {TIMELINE.map((item) => (
            <div key={item.company} className="about-tl-item">
              <div>
                <div className="about-tl-company">{item.company}</div>
                <div className="about-tl-role">{item.role}</div>
              </div>
              <div className="about-tl-desc">{item.desc}</div>
            </div>
          ))}
        </div>
      </FadeUp>

      <FadeUp as="section" className="about-section" delay={100}>
        <SectionTitle num="·" title="С какими брендами" titleEm="я работала" />
        {BRAND_GROUPS.map((group) => (
          <div key={group.industry} className="about-brands-group">
            <div className="about-brands-industry">{group.industry}</div>
            <div className="about-brands-row">{group.brands}</div>
          </div>
        ))}
      </FadeUp>

      <FadeUp as="section" className="about-section" delay={120}>
        <SectionTitle num="03" title="Как я" titleEm="работаю" />
        <div className="about-values-grid">
          {VALUES.map((item) => (
            <div key={item.title} className="about-value-card">
              <div className="about-value-icon">{item.icon}</div>
              <div className="about-value-title">{item.title}</div>
              <div className="about-value-desc">{item.desc}</div>
            </div>
          ))}
        </div>
      </FadeUp>

      <FadeUp as="section" className="about-section" delay={140}>
        <SectionTitle num="·" title="Мои" titleEm="результаты как руководителя" />
        <div className="about-ach-stats-row">
          {ACHIEVEMENTS.map((item) => (
            <div key={item.num} className="about-ach-stat">
              <div className="about-ach-stat-num">{item.num}</div>
              <div className="about-ach-stat-label">{item.label}</div>
            </div>
          ))}
        </div>
      </FadeUp>

      <FadeUp as="section" className="about-section" delay={160}>
        <SectionTitle num="04" title="Образование и" titleEm="развитие" />
        <div className="about-edu-list">
          {EDUCATION.map((text) => (
            <div key={text} className="about-edu-item">
              <div className="about-edu-dot" />
              <div className="about-edu-text">{text}</div>
            </div>
          ))}
        </div>
        <div className="about-book-row">
          {BOOKS.map((book) => (
            <span key={book} className="about-book-chip">
              {book}
            </span>
          ))}
        </div>
      </FadeUp>

      <FadeUp as="section" className="about-section" delay={180}>
        <SectionTitle num="05" title="Почему я создала" titleEm="MARKET DIR" />
        <div className="about-mission-block">
          <div className="about-mission-quote">
            Малому бизнесу тоже нужен директор по маркетингу,
            <br />
            <em>который знает, что делать</em>.
          </div>
          <p className="about-mission-sub">
            Но не всегда его можно нанять, а иногда штатный директор микробизнесу и не нужен. MARKET
            DIR создан, чтобы просто и понятно объяснить малому бизнесу функции маркетинга и показать
            его математику. Бесплатные инструменты, диагностика с выявлением потенциала роста и
            доступный план роста к желаемым показателям.
          </p>
        </div>
      </FadeUp>

      <FadeUp as="section" className="about-section" delay={200}>
        <SectionTitle num="06" title="С кем я" titleEm="работаю" />
        <div className="about-segments-grid">
          {SEGMENTS.map((item) => (
            <div
              key={item.title}
              className={`about-segment-card${item.fill ? ' about-segment-card--fill' : ''}`}
            >
              <div className="about-seg-tag">{item.tag}</div>
              <div className="about-seg-title">{item.title}</div>
              <div className="about-seg-desc">{item.desc}</div>
            </div>
          ))}
        </div>
      </FadeUp>

      <FadeUp as="section" className="about-section" delay={220}>
        <div className="about-community-card">
          <div className="about-community-badge">W</div>
          <div>
            <div className="about-community-title">Резидентка бизнес-сообщества Women Create</div>
            <div className="about-community-desc">
              Провожу открытые мероприятия по маркетингу и рекламе для участниц сообщества — делюсь
              экспертизой вживую, без формата «продающего вебинара».
            </div>
          </div>
        </div>
      </FadeUp>

      <FadeUp className="about-cta-block" delay={240}>
        <div className="about-cta-eyebrow">Готовы поговорить о вашем бизнесе?</div>
        <h2 className="about-cta-title">
          Начнём с <em>диагностики</em>
        </h2>
        <p className="about-cta-sub">
          90 минут. Разбираем ваши цифры, находим где теряются деньги, определяем с чего начать.
        </p>
        <button type="button" className="about-cta-btn" onClick={() => setMeetingOpen(true)}>
          Записаться на консультацию
        </button>
      </FadeUp>

      <MeetingRequestModal isOpen={isMeetingOpen} onClose={() => setMeetingOpen(false)} />
    </div>
  );
};

export default About;
